export const RESTRICTION_TYPE_EVERYONE = 'EVERYONE'
export const RESTRICTION_TYPE_GROUP = 'TEAMS'
export const RESTRICTION_TYPE_USERS = 'AGENTS'
export const RESTRICTION_TYPE_ME = 'ME'
